export const commandPaletteCommands = [
  {
    id: 'create-estimate',
    slash: '/estimate',
    title: 'New Estimate',
    subtitle: 'Start the first Repair Order stage',
    icon: 'fa-solid fa-file-circle-plus',
    action: 'create-estimate',
    keywords: ['create', 'new', 'estimate', 'repair order', 'quote'],
    primary: true,
  },
  {
    id: 'quote-alias',
    slash: '/quote',
    title: 'New Estimate',
    subtitle: 'Alias for /estimate',
    icon: 'fa-solid fa-file-pen',
    action: 'create-estimate',
    keywords: ['quote', 'estimate', 'create'],
  },
];
